import AssetTab from "./AssetTab";

export default AssetTab;
